import { useCallback } from "react";
import { ROWS_PER_PAGE } from "../../../../utils/constants";
import { usePaginatedData } from "./usePaginatedData";
import {
  getClients,
  IInternalClient,
  TClientStatus,
} from "../services/internalClientsService";

interface IUseInternalClientsOptions {
  status: TClientStatus;
  refreshDependency?: boolean | number;
}

/**
 * Hook for fetching and searching internal clients with pagination
 * Encapsulates common logic between InternalInvitations and InternalIntegrations
 */
export const useInternalClients = ({
  status,
  refreshDependency,
}: IUseInternalClientsOptions) => {
  const fetchClients = useCallback(
    async (page: number, search?: string) => {
      const { clients, count } = await getClients({
        status,
        skip: page,
        limit: ROWS_PER_PAGE,
        search,
      });
      return { data: clients, count };
    },
    [status, refreshDependency]
  );

  return usePaginatedData<IInternalClient>({ fetchFn: fetchClients });
};
